import { Text } from '@livechat/design-system-react-components';
import Cookies from 'js-cookie';

import { CustomLink } from 'components/link/Link';
import { removeItem } from 'helpers/storage/local-storage';

import * as styles from './styles';

export const CreateNewAccount = () => {
  const handleChangeEmail = () => {
    removeItem('signup');
    Cookies.remove('access_token');
  };

  return (
    <Text css={styles.action}>
      <span css={styles.desktopSpan}>Want to create a new account?&nbsp;</span>
      <CustomLink onClick={handleChangeEmail} to="/signup" dataTestId="use-another-email-link">
        Use another email
      </CustomLink>
      <span css={styles.mobileSpan}>for new account</span>
    </Text>
  );
};
